const CardHeaderStyles = theme => {
  return {
    root: {
    }
  };
};

export default CardHeaderStyles;
